import type { DailyScheduleDto } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import { DailyScheduleSlotEntity } from "@/modules/boxDashboard/modules/DailySchedule/entities/dailyScheduleSlotEntity"
import dayjs from "dayjs"

export class DailyScheduleSlotEntityBuilder {
  private dto: DailyScheduleDto

  static create() {
    return new DailyScheduleSlotEntityBuilder()
  }

  protected constructor() {
    this.dto = {
      slotId: "slot-default",
      slotStart: dayjs().hour(10).minute(0).second(0).toISOString(),
      slotEnd: dayjs().hour(11).minute(0).second(0).toISOString(),
      programName: "WOD",
      color: "#FF6B6B",
      assignedStaffMembers: {
        id: "coach-1",
        username: "sandra_graham",
        firstname: "Sandra",
        lastname: "Graham",
        avatar: null,
      },
      numberOfTrials: null,
      numberOfDropIns: null,
      numberOfParticipants: 10,
      numberOfActualParticipants: 8,
      numberOfPendingParticipants: 0,
    }
  }

  withSlotId(slotId: string) {
    this.dto.slotId = slotId
    return this
  }

  withSlotStart(slotStart: string) {
    this.dto.slotStart = slotStart
    return this
  }

  withSlotEnd(slotEnd: string) {
    this.dto.slotEnd = slotEnd
    return this
  }

  withTimeRange(startHour: number, startMinute: number, endHour: number, endMinute: number) {
    this.dto.slotStart = dayjs().hour(startHour).minute(startMinute).second(0).millisecond(0).toISOString()
    this.dto.slotEnd = dayjs().hour(endHour).minute(endMinute).second(0).millisecond(0).toISOString()
    return this
  }

  withPastTime() {
    this.dto.slotStart = dayjs().subtract(2, "hour").toISOString()
    this.dto.slotEnd = dayjs().subtract(1, "hour").toISOString()
    return this
  }

  withCurrentTime() {
    this.dto.slotStart = dayjs().subtract(15, "minute").toISOString()
    this.dto.slotEnd = dayjs().add(45, "minute").toISOString()
    return this
  }

  withUpcomingTime() {
    this.dto.slotStart = dayjs().add(1, "hour").toISOString()
    this.dto.slotEnd = dayjs().add(2, "hour").toISOString()
    return this
  }

  withProgramName(programName: string) {
    this.dto.programName = programName
    return this
  }

  withColor(color: string) {
    this.dto.color = color
    return this
  }

  withCoach(firstname: string, lastname: string) {
    this.dto.assignedStaffMembers = {
      id: `coach-${firstname.toLowerCase()}`,
      username: `${firstname.toLowerCase()}_${lastname.toLowerCase()}`,
      firstname,
      lastname,
      avatar: null,
    }
    return this
  }

  withoutCoach() {
    this.dto.assignedStaffMembers = null
    return this
  }

  withTrials(count: number) {
    this.dto.numberOfTrials = count
    return this
  }

  withDropIns(count: number) {
    this.dto.numberOfDropIns = count
    return this
  }

  withParticipants(actual: number, total: number, pending: number = 0) {
    this.dto.numberOfActualParticipants = actual
    this.dto.numberOfParticipants = total
    this.dto.numberOfPendingParticipants = pending
    return this
  }

  withWaitlist(count: number) {
    this.dto.numberOfPendingParticipants = count
    return this
  }

  withFullCapacity() {
    this.dto.numberOfActualParticipants = this.dto.numberOfParticipants
    return this
  }

  withEmptySlot() {
    this.dto.numberOfActualParticipants = 0
    return this
  }

  build(): DailyScheduleSlotEntity {
    return DailyScheduleSlotEntity.fromDto(this.dto)
  }

  buildDto(): DailyScheduleDto {
    return { ...this.dto }
  }
}
